import { render, staticRenderFns } from "./ViewMediation.vue?vue&type=template&id=2eb9d7a6&scoped=true&"
import script from "./ViewMediation.vue?vue&type=script&lang=ts&"
export * from "./ViewMediation.vue?vue&type=script&lang=ts&"
import style0 from "./ViewMediation.vue?vue&type=style&index=0&id=2eb9d7a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb9d7a6",
  null
  
)

/* custom blocks */
import block0 from "./ViewMediation.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCard,VCardText,VIcon,VSheet})
